"use client";
import React from 'react';
import { scrollToSection } from "@/components/navigation/scroll-to-section";
import Button from '@/components/primitives/button';


export default function ViewPicks() {
  return (
    <Button size="xs" onClick={() => scrollToSection("game-detail-pick-activity", 132)}>View Picks</Button>
  )
}
